import { number, ord, array } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { SalesforceArticleInfo } from '@mews-commander/data-access';

const ordArticles = pipe(
    number.Ord,
    ord.contramap((article: SalesforceArticleInfo) => article.viewCount)
);

export const sortArticles = array.sortBy([ordArticles]);

export const sanitazeSearchValue = (value: string) =>
    pipe(
        value,
        (s) => s.replace(/\?|&|\||!|\{|\}|\[|\]|\(|\)|\^|~|\*|:|\\|"|'|\+|-/gi, ''),
        (s) => s.trim()
    );
